import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { diversifiers } from '@/react-query/queries/ic-report/hooks'

const percentageFormatter = numberFormatter({
  suffix: '%',
  transformer: (val) => val * 100,
})

const colDefs = createColDefs([
  {
    field: 'idx',
    headerName: 'Index',
  },
  {
    field: 'daily_performance_annualised',
    headerName: 'Daily Performance Annualised',
    valueFormatter: percentageFormatter,
  },
  {
    field: 'daily_volatility',
    headerName: 'Daily Volatility',
    valueFormatter: percentageFormatter,
  },
  {
    field: 'skew',
    headerName: 'Skew',
    valueFormatter: numberFormatter(),
  },
  {
    field: 'mdd',
    headerName: 'MDD',
    valueFormatter: percentageFormatter,
  },
  {
    field: 'var',
    headerName: 'Var',
    valueFormatter: percentageFormatter,
  },
  {
    field: 'annualised_sharpe',
    headerName: 'Return / Volatility',
    valueFormatter: numberFormatter(),
  },
])

export interface DiversifierMetricsTableProps extends ICReportTablePrimitive {}

export const DiversifierMetricsTable: React.FC<DiversifierMetricsTableProps> = ({
  params,
  options,
}) => {
  const query = diversifiers.useMetrics(params)
  const data = query.data ?? []

  return <CustomAgGrid rowData={data} columnDefs={colDefs} {...options} />
}
